import * as e from "react";
import r from "@appchoose/cn";
import { Dialog as n, DialogContent as s } from "@appchoose/dialog";
import p from "@appchoose/icon";
import { Command as m } from "cmdk";
const d = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(
  m,
  {
    ref: o,
    className: r(
      "text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md bg-white",
      a
    ),
    ...t
  }
));
d.displayName = m.displayName;
const k = ({ children: a, ...t }) => /* @__PURE__ */ e.createElement(n, { ...t }, /* @__PURE__ */ e.createElement(s, { className: "overflow-hidden p-0 shadow-lg" }, /* @__PURE__ */ e.createElement(d, { className: "[&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5" }, a))), l = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "" }, /* @__PURE__ */ e.createElement(p, { icon: "search", className: "mr-2 shrink-0 opacity-50" }), /* @__PURE__ */ e.createElement(
  m.Input,
  {
    ref: o,
    className: r(
      "placeholder:text-muted-foreground flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50",
      a
    ),
    ...t
  }
)));
l.displayName = m.Input.displayName;
const c = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(
  m.List,
  {
    ref: o,
    className: r("max-h-[300px] overflow-y-auto overflow-x-hidden", a),
    ...t
  }
));
c.displayName = m.List.displayName;
const i = e.forwardRef((a, t) => /* @__PURE__ */ e.createElement(
  m.Empty,
  {
    ref: t,
    className: "py-4 text-center text-sm",
    ...a
  }
));
i.displayName = m.Empty.displayName;
const u = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(
  m.Group,
  {
    ref: o,
    className: r(
      "overflow-hidden p-1 text-gray-700 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-gray-500",
      a
    ),
    ...t
  }
));
u.displayName = m.Group.displayName;
const g = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(
  m.Separator,
  {
    ref: o,
    className: r("bg-border -mx-1 h-px", a),
    ...t
  }
));
g.displayName = m.Separator.displayName;
const f = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(
  m.Item,
  {
    ref: o,
    className: r(
      "relative flex cursor-pointer select-none items-center rounded-sm p-2 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-green-300 data-[selected=true]:text-gray-900 data-[disabled=true]:opacity-50",
      a
    ),
    ...t
  }
));
f.displayName = m.Item.displayName;
const x = e.forwardRef(({ className: a, ...t }, o) => /* @__PURE__ */ e.createElement(m.Loading, { ref: o, className: a, ...t }));
x.displayName = "CommandLoading";
const y = ({
  className: a,
  ...t
}) => /* @__PURE__ */ e.createElement(
  "span",
  {
    className: r(
      "text-muted-foreground ml-auto text-xs tracking-widest",
      a
    ),
    ...t
  }
);
y.displayName = "CommandShortcut";
export {
  d as Command,
  k as CommandDialog,
  i as CommandEmpty,
  u as CommandGroup,
  l as CommandInput,
  f as CommandItem,
  c as CommandList,
  x as CommandLoading,
  g as CommandSeparator,
  y as CommandShortcut
};
